import request from '../utils/request';

// 首页板块文案（新品/热门/推荐等）
export const fetchHomeSections = () => request.get('/admin/home-content/sections');
export const updateHomeSections = data => request.put('/admin/home-content/sections', data);
